import { useMatches } from "@tanstack/react-router";

export function useIsMyFileTemplate() {
  const matches = useMatches();

  return matches.some(
    (match) => match.routeId === "/_auth/_app-shell/my-files/template",
  );
}
